import { useAuth } from '@/context/AuthContext';
import { UnauthorizedAccess } from './UnauthorizedAccess';
import type { UserProfile } from '@/api/auth/auth.types';

interface PermissionAwareRouteProps {
  children: React.ReactNode;
  requiredPermission: keyof UserProfile['permissions'];
}

export function PermissionAwareRoute({ children, requiredPermission }: PermissionAwareRouteProps) {
  const { user } = useAuth();
  
  // Check if user and permissions exist
  if (!user?.permissions) {
    return <UnauthorizedAccess />;
  }

  const permissionLevel = user.permissions[requiredPermission];
  
  // Check if permission exists and is not RESTRICTED or empty
  if (!permissionLevel || permissionLevel === 'RESTRICTED' || permissionLevel === '') {
    return <UnauthorizedAccess />;
  }

  // Only allow if permission is VIEWER or EDITOR
  if (!['VIEWER', 'EDITOR'].includes(permissionLevel)) {
    return <UnauthorizedAccess />;
  }

  return <>{children}</>;
}
